import { Spanish } from 'flatpickr/dist/l10n/es';


/* Default Values */
export const WebApiServerHostUrlDefault = "$webApiServerHostUrl";

/* External Variables */
export const ServicesUrlKey = "minhac.settings.ServicesUrl";

export const Constants = {
    Common: {
        DateFormat: "dd/MM/yyyy"

    },
    Subscriptions : {
        Login: '/api/subscriptions/Login',
        CreateUser: '/api/subscriptions/CreateUser',
        ActivateUser: '/api/subscriptions/ActivateUser',
        RecoveryAccountSendMail: '/api/subscriptions/RecoveryAccountSendEmail',
        RecoveryAccountSendPassword: '/api/subscriptions/RecoveryAccountSendPassword',
        ChangePassword: '/api/subscriptions/ChangePassword',
        UpdateUser: '/api/subscriptions/UpdateUser',
        GetSitePublications: '/api/subscriptions/GetSitePublications',
        UpdateUserSubscriptions: '/api/subscriptions/UpdateUserSubscriptions',
        CheckJwtValidity: '/api/subscriptions/CheckJwtValidity',
        SendNewActivationEmail: '/api/subscriptions/SendNewActivationEmail'
    },
    Literals: {
        Hasta: '(hasta)',
        RecoveryAccountModal: 'Se va a proceder al envio de un correo de recuperación de contraseña al email indicado',
        RecoveryAccountModalMailSended: 'Si el correo electrónico está registrado habrá recibido un email en su bandeja de entrada',
        Ok: 'Ok',
        Cancel: 'Cancelar'
    },
    FieldTypes: {
        Text: "text",
        CheckBox: "checkbox",
        Password: "password"
    },
    AppViews:{
        Key: "Susbcriptions_View",
        NewUser: "NewUser_Susbcriptions",
        UserAdministration: "UserAdministration_Susbcriptions",
        RecoveryPassword: "RecoverPassword_Susbcriptions"
    },
    PageUrls:{
        Subscriptions: "/{idioma}/Paginas/GestionSuscripciones.aspx"
    },
    Keys:{
        GenericVariant: "{idioma}",
        DefaultVariant: "es-es",
        GroupId: 2,
        AppId: 2,
        Email: "email",
        Sms: "sms",
        EmailText: "Email",
        SmsText: "SMS",
        SmsChannelId: 1,
        EmailChannelId: 2
    },
    SessionStorage:{
        UserToken: "userToken"
    },
    Variants: ["es-es", "ca-es", "gl-es", "eu-es", "en-gb"]
} 


// Subscriptions Service Requests

export const LoginRequest = {
    userEmail: "",
    password: "",
    languageKey: "",
    groupId: Constants.Keys.GroupId,
    appId: Constants.Keys.AppId,
    captchaKey: ""
}

export const RecoveryAccountSendEmailRequest = {
    email: "",
    appId: Constants.Keys.AppId,
    captchaKey: ""
}

export const GetSitePublicationsRequest = {
    body:{
        siteUrl: "",
        languageKey: ""
    },
    jwtoken : ""
}

export const UpdateUserSubscriptionsRequest = {
    body:{
        subscriptions: []
    },
    jwtoken : ""
}

export const CheckJwtValidityRequest = {
    body:{},
    jwtoken : ""
}

export const SendActivationMailRequest = {
    email: "",
    appId: Constants.Keys.AppId    
}